import React, { useState } from 'react';
import { Fullscreen, Close } from '@mui/icons-material';
import { useFecharComEsc } from '../../utils/useFecharComEsc';

interface CartaoExpansivelProps {
  /** Título mostrado no cabeçalho do modal de tela cheia. */
  titulo: React.ReactNode;
  /** Altura do conteúdo no tamanho normal (ex: 420, "420px"). */
  alturaNormal: string | number;
  /** Altura do conteúdo dentro do modal de tela cheia. */
  alturaTelaCheia?: string;
  /**
   * Função que constrói o conteúdo (gráfico Recharts, mapa Leaflet, o que
   * for) pra uma altura dada — chamada uma vez com `alturaNormal` (posição
   * normal) e, quando expandido, de novo com `alturaTelaCheia` dentro do
   * modal. Genérico de propósito: este componente não sabe nada sobre
   * gráfico/mapa/dados, só sobre "expandir uma área em tela cheia".
   */
  children: (altura: string | number) => React.ReactNode;
}

/**
 * Botão de expandir reaproveitável por qualquer gráfico/mapa do Dashboard
 * — cada instância é independente (um card expandido não afeta os outros).
 * Renderiza o CONTEÚDO só uma vez por vez (normal OU tela cheia), nunca os
 * dois montados ao mesmo tempo.
 */
const CartaoExpansivel: React.FC<CartaoExpansivelProps> = ({ titulo, alturaNormal, alturaTelaCheia = '75vh', children }) => {
  const [telaCheia, setTelaCheia] = useState(false);
  useFecharComEsc(telaCheia, () => setTelaCheia(false));

  if (telaCheia) {
    return (
      <div style={{ position: 'relative' }}>
        {children(alturaNormal)}
        <div style={backdropStyle} onClick={() => setTelaCheia(false)}>
          <div style={modalStyle} onClick={(e) => e.stopPropagation()}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '14px', gap: '10px' }}>
              <strong style={{ fontSize: '1rem', color: '#333' }}>{titulo}</strong>
              <button type="button" title="Fechar" onClick={() => setTelaCheia(false)} style={fecharBtnStyle}>
                <Close fontSize="small" />
              </button>
            </div>
            {children(alturaTelaCheia)}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div style={{ position: 'relative' }}>
      <button type="button" title="Expandir em tela cheia" onClick={() => setTelaCheia(true)} style={botaoStyle}>
        <Fullscreen fontSize="small" />
      </button>
      {children(alturaNormal)}
    </div>
  );
};

const botaoStyle: React.CSSProperties = {
  position: 'absolute', top: '8px', right: '8px', zIndex: 5,
  width: '30px', height: '30px', borderRadius: '6px', border: '1px solid #ddd',
  background: '#fff', color: '#666', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center',
  boxShadow: '0 1px 3px rgba(0,0,0,0.15)',
};
const fecharBtnStyle: React.CSSProperties = {
  width: '30px', height: '30px', borderRadius: '6px', border: '1px solid #ddd', flexShrink: 0,
  background: '#fff', color: '#666', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center',
};
const backdropStyle: React.CSSProperties = {
  position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', zIndex: 2000,
  display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '24px',
};
const modalStyle: React.CSSProperties = {
  background: '#fff', borderRadius: '12px', padding: '20px', width: '100%', maxWidth: '1200px',
  maxHeight: '90vh', overflow: 'auto', boxShadow: '0 12px 40px rgba(0,0,0,0.3)', boxSizing: 'border-box',
};

export default CartaoExpansivel;
